import { AuditLogTable, PageHeader, useAuth } from "@nexys/user-management-web";
import { Navigate } from "react-router-dom";

export const AuditLogsPage = () => {
  const { hasUserRole } = useAuth();
  if (!hasUserRole("superadmin")) return <Navigate to="/" replace />;

  return (
    <div className="grid gap-6">
      <PageHeader
        title="Access logs"
        description="Authentication and admin activity across the server, newest first."
      />
      <AuditLogTable />
    </div>
  );
};
